/* Grasp Internet theme — motion & interaction module (~2.5 KB)
   Mirrors docs/06-animation-interaction-plan.md.
   Re-initializes on shopify:section:load so the theme editor stays live. */
(function () {
  'use strict';

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* 1. Header: transparent over hero -> solid on scroll */
  function initHeader() {
    var header = document.querySelector('.site-header');
    if (!header || header.dataset.bound) return;
    header.dataset.bound = '1';
    var onScroll = function () {
      header.classList.toggle('is-solid', window.scrollY > 24);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* 2. Scroll reveals */
  var io = null;
  function initReveals(root) {
    var els = (root || document).querySelectorAll('.reveal:not(.is-visible), .reveal-stagger:not(.is-visible)');
    if (!els.length) return;
    if (reduced || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    if (!io) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add('is-visible');
            io.unobserve(e.target);
          }
        });
      }, { threshold: 0, rootMargin: '0px 0px -8% 0px' });
      /* threshold MUST be 0: a container taller than ~8x the viewport can
         never reach a fractional threshold, so it would stay invisible
         forever (the 19-product grid is 11,150px tall on a phone). */
    }
    els.forEach(function (el) { io.observe(el); });
  }

  /* 3. Mobile menu: toggle + Escape + focus containment + breakpoint close */
  function initMobileMenu() {
    var toggle = document.querySelector('.nav-toggle');
    var menu = document.querySelector('.mobile-menu');
    if (!toggle || !menu || toggle.dataset.bound) return;
    toggle.dataset.bound = '1';
    var openLabel = toggle.getAttribute('aria-label');
    var closeLabel = toggle.dataset.labelClose || openLabel;

    function setOpen(open) {
      menu.classList.toggle('is-open', open);
      toggle.setAttribute('aria-expanded', open);
      toggle.setAttribute('aria-label', open ? closeLabel : openLabel);
      document.body.style.overflow = open ? 'hidden' : '';
      document.documentElement.classList.toggle('menu-open', open);
      if (open) {
        var first = menu.querySelector('a, button');
        if (first) first.focus();
      } else {
        toggle.focus();
      }
    }

    toggle.addEventListener('click', function () {
      setOpen(!menu.classList.contains('is-open'));
    });

    document.addEventListener('keydown', function (e) {
      if (!menu.classList.contains('is-open')) return;
      if (e.key === 'Escape') {
        setOpen(false);
        return;
      }
      if (e.key === 'Tab') {
        var focusables = menu.querySelectorAll('a, button');
        if (!focusables.length) return;
        var list = Array.prototype.slice.call(focusables);
        list.unshift(toggle);
        var idx = list.indexOf(document.activeElement);
        if (e.shiftKey && (idx <= 0)) {
          e.preventDefault();
          list[list.length - 1].focus();
        } else if (!e.shiftKey && idx === list.length - 1) {
          e.preventDefault();
          list[0].focus();
        }
      }
    });

    if (window.matchMedia) {
      var mq = window.matchMedia('(min-width: 861px)');
      var onChange = function (e) { if (e.matches && menu.classList.contains('is-open')) setOpen(false); };
      if (mq.addEventListener) mq.addEventListener('change', onChange);
      else if (mq.addListener) mq.addListener(onChange);
    }
  }

  /* 3b. Lazy-image backstop.
     Native loading="lazy" was never firing for images far down very tall pages
     (measured: 16 of 19 product images had no currentSrc even after a full
     scroll). Flipping an already-parsed image to eager starts the fetch, so we
     promote them as they approach the viewport. */
  var lazyIO = null;
  function initLazyImages(root) {
    var imgs = (root || document).querySelectorAll('img[loading="lazy"]:not([data-lazy-bound])');
    if (!imgs.length) return;
    if (!('IntersectionObserver' in window)) {
      imgs.forEach(function (i) { i.setAttribute('loading', 'eager'); });
      return;
    }
    if (!lazyIO) {
      lazyIO = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.setAttribute('loading', 'eager');
            lazyIO.unobserve(e.target);
          }
        });
      }, { rootMargin: '800px 600px' });
    }
    imgs.forEach(function (i) {
      i.dataset.lazyBound = '1';
      lazyIO.observe(i);
    });
  }

  /* 4. Accordions */
  function initAccordions(root) {
    (root || document).querySelectorAll('.accordion-trigger').forEach(function (btn) {
      if (btn.dataset.bound) return;
      btn.dataset.bound = '1';
      btn.addEventListener('click', function () {
        var item = btn.closest('.accordion-item');
        var open = item.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open);
      });
    });
  }

  /* 5. Filter chips (portfolio grid) */
  function initFilters(root) {
    (root || document).querySelectorAll('.filter-bar').forEach(function (bar) {
      if (bar.dataset.bound) return;
      bar.dataset.bound = '1';
      bar.addEventListener('click', function (e) {
        var chip = e.target.closest('.filter-chip');
        if (!chip) return;
        bar.querySelectorAll('.filter-chip').forEach(function (c) {
          c.classList.remove('is-active');
          c.setAttribute('aria-pressed', 'false');
        });
        chip.classList.add('is-active');
        chip.setAttribute('aria-pressed', 'true');
        var key = (chip.dataset.filter || 'all').toLowerCase();
        var scope = bar.closest('.shopify-section') || document;
        scope.querySelectorAll('[data-product]').forEach(function (card) {
          var match = key === 'all'
            || (card.dataset.brand || '').toLowerCase() === key
            || (card.dataset.category || '').toLowerCase() === key;
          card.style.display = match ? '' : 'none';
        });
      });
    });
  }

  function initAll(root) {
    document.documentElement.classList.add('motion-ready');
    initHeader();
    initMobileMenu();
    initReveals(root);
    initLazyImages(root);
    initAccordions(root);
    initFilters(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  /* Theme editor: sections load dynamically */
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
